var noop = (function () {
  // nothing to do here
});export{noop as default};